import 'focus-visible';

export default class FocusVisible {
  init() {
    window.addEventListener('focus-visible-polyfill-ready',
    () => window.applyFocusVisiblePolyfill(myComponent.shadowRoot),
    { once:  true });
  }
}
